import i18n from './../../shared/i18n';
import BaseModel, {defineTranslatableProperties} from "../../core/components/input-widget/BaseModel";
import _ from 'lodash';
import {Formatter} from "@/core/services/formatter.service";
import {store} from "@/plugins/vuex";

export default class ReceiptSearch extends BaseModel {
  department_uuid = null;
  receipt_no = null;
  date = null;
  customer_uuid = null;
  description = null;
  receipt_contract_status = null;
  pre_receipt_contract_status = null;
  status = null;
  rep_user_uuid = null;
  item_location_uuid = null;
  dropper_uuid = null;
  enable_multiple_locations = null;
  container_type = null;
  location_note = null;
  has_internal_images = false;
  has_attachments = false;
  rules = {};

  attributeLabels = {
    department_uuid: i18n.t('Department'),
    receipt_no: i18n.t('Receipt'),
    date: i18n.t('Date'),
    customer_uuid: i18n.t('Customer'),
    description: i18n.t('Description'),
    accounting_code: i18n.t('Accounting Code'),
    receipt_contract_status: i18n.t('Consignment Status'),
    pre_receipt_contract_status: i18n.t('Pre-Consignment Status'),
    status: i18n.t('Status'),
    item_location_uuid: i18n.t('Item Location'),
    enable_multiple_locations: i18n.t('Multi-Item Location'),
    container_type: i18n.t('Multi-Item Location Container'),
    location_note: i18n.t('Note'),
    has_internal_images: i18n.t('Has Internal Images'),
    has_attachments: i18n.t('Has Attachments'),
  };

  attributePlaceholders = this.attributeLabels;

  constructor(data = {}) {
    super();
    Object.assign(this, {...data});
  }

  toJSON() {
    let data = super.toJSON();
    delete data.department;
    delete data.customer;
    delete data.specialist;
    delete data.dropper;
    delete data.rep_user;
    delete data.recommended_by_user;

    if (store.state && store.state.global && store.state.global.dynamicFieldsFilters) {
      let receiptDynamicFieldsFilters = store.state.global.dynamicFieldsFilters.receipts;
      if (receiptDynamicFieldsFilters && receiptDynamicFieldsFilters.length > 0) {
        for (let field of receiptDynamicFieldsFilters) {
          if (field.type === 'checkbox') {
            data[field.key] ? data[field.key] = 'true' : delete data[field.key]
          }
        }
      }
    }

    data.has_internal_images ? data.has_internal_images = 'true' : data.has_internal_images = 'false'
    data.has_attachments ? data.has_attachments = 'true' : data.has_attachments = 'false'

    return data;
  }

  getFilteredData() {
    let returnData = [];

    const data = this.toJSON();

    for (let attr in data) {
      if (data[attr]) {
        let label = this.attributeLabels[attr];
        let value = _.capitalize(data[attr]);

        if (attr === 'department_uuid') {
          value = _.capitalize(Formatter.getByMasterLanguage(this.department.name));
        } else if (attr === 'customer_uuid') {
          value = _.capitalize(this.customer.display_name);
        }

        let text = `${label}: ${value}`;
        returnData.push({text, attr});
      }
    }

    return returnData;
  }
}

defineTranslatableProperties(ReceiptSearch);
